import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

import { ThemedConnectorIconPlus } from "assets/CXFIcons/Designer/Toolbox";

import TitlebarActionWrapper from "layouts/Flow Designer/components/Titlebar/components/TitlebarActions/TitleActionsWrapper";

import { openRegisterComponentDialog } from "redux/actions/flowDesigner/cxfComponentsActionCreator";

const ToolboxDetailRegisterConnector = () => {
  const { t } = useTranslation("flowDesigner");
  const dispatch = useDispatch();

  const registerComponent = () => {
    dispatch(openRegisterComponentDialog());
  };
  return (
    <Box>
      <Divider />
      <Box sx={{ lineHeight: "12px" }}>
        <TitlebarActionWrapper
          title={t("buttons.register_connector")}
          allowText
          action={registerComponent}
        >
          <ThemedConnectorIconPlus />
        </TitlebarActionWrapper>
      </Box>
    </Box>
  );
};

export default ToolboxDetailRegisterConnector;
